import { css } from '@emotion/react';
import { media } from '@utex/ui-kit';

export const stylesUTCom = css`
  :root {
    --typo-text-fs-xxs: 1.2rem;
    --typo-text-lh-xxs: 1.8rem;
    --typo-text-fs-xs: 1.3rem;
    --typo-text-lh-xs: 2rem;
    --typo-text-fs-xsch: 1.3rem;
    --typo-text-lh-xsch: 1.8rem;
    --typo-text-fs-s: 1.4rem;
    --typo-text-lh-s: 2rem;
    --typo-text-fs-sch: 1.4rem;
    --typo-text-lh-sch: 1.8rem;
    --typo-text-fs-m: 1.5rem;
    --typo-text-lh-m: 1.333;
    --typo-text-fs-mch: 1.5rem;
    --typo-text-lh-mch: 1.8rem;
    --typo-text-fs-l: 1.8rem;
    --typo-text-lh-l: 2.4rem;
    --typo-text-fs-xl: 2.4rem;
    --typo-text-lh-xl: 2.8rem;
    --typo-text-fs-xxl: 3.2rem;
    --typo-text-lh-xxl: 3.6rem;
    --typo-text-fs-xxxl: 4.6rem;
    --typo-text-lh-xxxl: 5.4rem;
  }

  html {
    overflow-y: scroll;
  }

  #___gatsby {
    height: inherit;
  }

  #gatsby-focus-wrapper {
    display: flex;
    flex-direction: column;
    min-height: 100%;
  }

  // TODO: there is no way to hide zendesk button in new version.
  // Fix it after "kind of zESettings" release
  iframe[data-product='web_widget'] ~ div > div > iframe {
    @media ${media.phonablet} {
      display: none !important;
    }
  }
`;
